import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

export const withQueryClient = (component: () => React.ReactNode) => () => {
  const [queryClient] = useState(new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {component()}
    </QueryClientProvider>
  );
};
